// src/pricing/useQuote.js
import { useMemo, useState } from "react";
import {
  recomputeAll,
  rsdToEur,
  setMaterialPriceByThickness,
  setMaterialRowPrice,
  setDiscounts,
} from "./priceEngine";



export function useQuote(initialQuote) {
  const [quote, setQuote] = useState(() => recomputeAll(initialQuote || {}));
  const [currency, setCurrency] = useState(
    (initialQuote && initialQuote.currency) || "RSD"
  );

  const totals = useMemo(() => {
    const toEUR = (v) => rsdToEur(v, quote.euro_rate);
    if (currency === "EUR") {
      return {
        currency: "EUR",
        materials: {
          subtotal: toEUR(quote.materials.subtotal),
          discount: toEUR(quote.materials.discount_value),
          total: toEUR(quote.materials.total),
        },
        equipment: {
          subtotal: toEUR(quote.equipment.subtotal),
          discount: toEUR(quote.equipment.discount_value),
          total: toEUR(quote.equipment.total),
        },
        services: {
          subtotal: toEUR(quote.services.subtotal),
          discount: toEUR(quote.services.discount_value),
          total: toEUR(quote.services.total),
        },
        grand: {
          subtotal: toEUR(quote.grand_subtotal),
          discount: toEUR(quote.grand_discount),
          total: toEUR(quote.grand_total),
        },
      };
    }
    return {
      currency: "RSD",
      materials: {
        subtotal: quote.materials.subtotal,
        discount: quote.materials.discount_value,
        total: quote.materials.total,
      },
      equipment: {
        subtotal: quote.equipment.subtotal,
        discount: quote.equipment.discount_value,
        total: quote.equipment.total,
      },
      services: {
        subtotal: quote.services.subtotal,
        discount: quote.services.discount_value,
        total: quote.services.total,
      },
      grand: {
        subtotal: quote.grand_subtotal,
        discount: quote.grand_discount,
        total: quote.grand_total,
      },
    };
  }, [quote, currency]);

  return {
    quote,
    currency,
    setCurrency,
    totals,

    // actions
    applyMaterialPriceFromViewer: (
      sceneMaterial,
      guessThickness,
      pricePerM2_RSD
    ) =>
      setQuote((q) =>
        setMaterialPriceByThickness(
          q,
          sceneMaterial,
          guessThickness,
          pricePerM2_RSD
        )
      ),
    setMaterialRowPrice: (idx, pricePerM2_RSD) =>
      setQuote((q) => setMaterialRowPrice(q, idx, pricePerM2_RSD)),
    setDiscounts: (next) => setQuote((q) => setDiscounts(q, next)),
    replaceQuote: (next) => setQuote(recomputeAll(next)),
  };
}
